/* eslint-disable react/no-unused-prop-types */
import { arrayOf, shape, string } from 'prop-types';
import { without } from 'lodash';
import { t } from '@lingui/macro';

import Filter from '../../page-framework/filter/FilterDecorator';
import { filterPropTypes, filterPropDefaults } from '../../page-framework/filter/FilterPropTypes';
import { StatusFilter, stateType } from '../status-filter/StatusFilter';
import getStatusFilterStateServiceFactory from '../status-filter/StatusFilterStateService';
import { orderedStatuses, gray, green } from '../../../utilities/StatusUtilities';

export const filterTitle = t`Severity`;
export const filterId = 'Severity';

const statuses = without(orderedStatuses, gray, green);

function SeverityFilter({ state, filterActions }) {
    return <StatusFilter options={{ statuses }} state={state} filterActions={filterActions} />;
}

SeverityFilter.propTypes = {
    id: filterPropTypes.id,
    title: filterPropTypes.title,
    filterActions: filterPropTypes.filterActions,
    state: stateType,
    options: shape({
        statuses: arrayOf(string),
    }),
};

SeverityFilter.defaultProps = {
    ...filterPropDefaults,
    id: filterId,
    title: filterTitle,
    state: undefined,
};

export default Filter({
    filterId,
    filterStateServiceFactory: getStatusFilterStateServiceFactory(filterTitle, 'severity'),
})(SeverityFilter);
